export default __webpack_public_path__ + "static/media/USDT.e.006177e6.png";